module.exports = __webpack_public_path__ + "static/claims5-d199e2d12adb577acb0ba940056385d9.svg";